import { isCapabilityEnabled } from 'owa-capabilities';
import { dimeUnipuxCapability } from 'owa-capabilities-definitions/lib/dimeUnipuxCapability';
import { lazyLaunchDimeModal, DimeModalEntrypoint } from 'owa-dime-modal';
import { getModuleContextMailboxInfo } from 'owa-module-context-mailboxinfo';
import { BUY_MICROSOFT365_LINK } from '../constants/constants';

export default function onBuyMicrosoft365ButtonClicked(): void {
    const mailboxInfo = getModuleContextMailboxInfo();
    const openBuyMicrosoft365Link = () => {
        window.open(BUY_MICROSOFT365_LINK, '_blank', 'noopener noreferrer');
    };
    if (isCapabilityEnabled(dimeUnipuxCapability, mailboxInfo)) {
        lazyLaunchDimeModal.importAndExecute(
            DimeModalEntrypoint.PersistentHeader,
            openBuyMicrosoft365Link,
            mailboxInfo
        );
    } else {
        openBuyMicrosoft365Link();
    }
}
